export const defaultLandingContent = {
  brand: "Irmãs das promos",
  hero: {
    kicker: null,
    titleParts: ["Você tá pagando caro sem precisar.", "As melhores promoções e cupons chegam aqui antes de todo mundo.",],
    highlightWord: "As melhores promoções e cupons chegam aqui antes de todo mundo.",
    subtitle: "Produtos com 50%, 60% e até 70% OFF.",
    ctaText: "ENTRAR NO GRUPO DE PROMOÇÕES",
    ctaHref: "https://sndflw.com/i/irmasdaspromos",
    proofText: "Mais de 80.000 membros ativos",
    urgencyText: "Restam 24 vagas",
  },
  benefits: {
    title: "O que você encontrará no grupo?",
    noteTop: "Vagas limitadas",
    ctaLabel: "Acessar grupo gratuito",
    items: [
      "Promoções reais em roupas, tênis, perfumes e acessórios",
      "Cupons exclusivos que não aparecem nas lojas",
      "Ofertas por tempo limitado (quem vê primeiro, compra)",
      "Links diretos para lojas oficiais e confiáveis",
      "Sem spam e com total liberdade para sair quando quiser",
    ],
  },
  howItWorks: {
    title: "BLOCO 2 — COMO FUNCIONA",
    lead: "Nada de texto longo. Só isso:",
    cardTitle: "Como funciona o BLACK CLUB",
    steps: ["A gente encontra", "A gente avalia", "A gente aprova", "Você acessa enquanto estiver ativo"],
  },
  why: {
    title: "BLOCO 3 — POR QUE EXISTE",
    lead: "Texto curto, de autoridade:",
    textLines: ["Nem todo mundo tem tempo pra procurar.", "E quem sabe escolher, prefere confiar em curadoria.", "", "Aqui não tem excesso.", "Só o que faz sentido."],
  },
  trust: {
    title: "BLOCO 4 — PROVA / SEGURANÇA (SEM PROMETER DEMAIS)",
    bullets: ["Curadoria diária", "Produtos aprovados", "Acesso limitado", "Compra online segura"],
  },
  finalCta: {
    title: "CTA FINAL (IMPORTANTE)",
    ctaText: "ENTRAR NO GRUPO DE PROMOÇÕES",
    microText: "Se estiver ativo, ainda dá tempo.",
  },
  footer: {
    note: "BLACK CLUB não implora clique. Ele autoriza acesso.",
  },
};
